/* sumi matcha theme scripts: cart drawer, search, forms */
(function () {
  var S = window.SUMI || {};
  var FREE = S.freeShip || 4000;
  var COPY = S.copy || {};
  Object.keys(COPY).forEach(function (key) {
    if (typeof COPY[key] !== 'string') return;
    COPY[key] = COPY[key]
      .replace(/&amp;#39;/gi, "'")
      .replace(/&amp;#x27;/gi, "'")
      .replace(/&#39;/gi, "'")
      .replace(/&#x27;/gi, "'")
      .replace(/&apos;/gi, "'");
  });

  /* ---------- navigation ---------- */
  var shopToggle = document.querySelector('.shop-toggle');
  var shopDrop = shopToggle ? shopToggle.closest('.has-drop') : null;
  if (shopToggle && shopDrop && shopToggle.tagName === 'BUTTON') {
    shopToggle.addEventListener('click', function () {
      var isOpen = shopDrop.classList.toggle('open');
      shopToggle.setAttribute('aria-expanded', String(isOpen));
    });
    document.addEventListener('click', function (e) {
      if (!shopDrop.contains(e.target)) {
        shopDrop.classList.remove('open');
        shopToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  var menuButton = document.querySelector('.menu-btn');
  var mobileMenu = document.getElementById('mobile-menu');
  var mobileClose = document.querySelector('[data-mobile-close]');
  if (mobileMenu && mobileMenu.parentNode !== document.body) document.body.appendChild(mobileMenu);
  var mobileMenuTimer;
  function setMobileMenu(open) {
    if (!menuButton || !mobileMenu) return;
    window.clearTimeout(mobileMenuTimer);
    if (open) {
      mobileMenu.style.transform = '';
      mobileMenu.style.transition = '';
      mobileMenu.removeAttribute('hidden');
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { mobileMenu.classList.add('is-open'); });
      });
    } else {
      mobileMenu.classList.remove('is-open');
      closePredictivePanels();
      mobileMenuTimer = window.setTimeout(function () {
        if (menuButton.getAttribute('aria-expanded') === 'false') mobileMenu.setAttribute('hidden', '');
      }, 420);
    }
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? (menuButton.getAttribute('data-close-label') || 'close menu') : (menuButton.getAttribute('data-open-label') || 'open menu'));
    document.body.classList.toggle('mobile-menu-open', open);
  }
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', function () {
      setMobileMenu(menuButton.getAttribute('aria-expanded') !== 'true');
    });
    if (mobileClose) mobileClose.addEventListener('click', function () { setMobileMenu(false); });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 1200 && !mobileMenu.hasAttribute('hidden')) setMobileMenu(false);
    });
  }

  document.querySelectorAll('[data-starter-post-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var dialog = document.getElementById(trigger.getAttribute('data-starter-post-open'));
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      window.history.replaceState(null, '', '#' + dialog.id);
    });
  });
  document.querySelectorAll('.starter-post-dialog').forEach(function (dialog) {
    var close = dialog.querySelector('[data-starter-post-close]');
    function closeStarterPost() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      if (window.location.hash === '#' + dialog.id) window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    if (close) close.addEventListener('click', closeStarterPost);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeStarterPost();
    });
  });
  if (window.location.hash.indexOf('#starter-post-') === 0) {
    var linkedStarterPost = document.querySelector(window.location.hash);
    if (linkedStarterPost && linkedStarterPost.classList.contains('starter-post-dialog')) {
      if (typeof linkedStarterPost.showModal === 'function') linkedStarterPost.showModal();
      else linkedStarterPost.setAttribute('open', '');
    }
  }
  var mobileShopToggle = document.querySelector('[data-mobile-shop-toggle]');
  if (mobileShopToggle) {
    mobileShopToggle.addEventListener('click', function () {
      var panel = mobileShopToggle.closest('.mobile-shop-panel');
      if (!panel) return;
      var opening = !panel.classList.contains('is-open');
      panel.classList.toggle('is-open', opening);
      mobileShopToggle.setAttribute('aria-expanded', String(opening));
      var sign = mobileShopToggle.querySelector('.mobile-summary-sign');
      if (sign) sign.textContent = opening ? '−' : '+';
    });
  }

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + v;
  }

  /* ---------- search bar ---------- */
  var sb = document.getElementById('searchbar');
  var openSearch = document.getElementById('open-search');
  if (sb && openSearch) {
    openSearch.addEventListener('click', function () {
      sb.classList.toggle('open');
      if (sb.classList.contains('open')) {
        var i = document.getElementById('search-input');
        if (i) i.focus();
      }
    });
    var sc = document.getElementById('search-close');
    if (sc) sc.addEventListener('click', function () {
      sb.classList.remove('open');
      closePredictivePanels();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        sb.classList.remove('open');
        closePredictivePanels();
      }
    });
  }
  var mobileSearch = document.querySelector('[data-mobile-search]');
  if (mobileSearch && sb) {
    mobileSearch.addEventListener('click', function () {
      sb.classList.add('open');
      setMobileMenu(false);
      var input = document.getElementById('search-input');
      if (input) input.focus();
    });
  }

  function closePredictivePanels() {
    document.querySelectorAll('[data-predictive-search]').forEach(function (predictiveRoot) {
      predictiveRoot.dispatchEvent(new CustomEvent('predictive-search:close'));
    });
  }

  function initPredictiveSearch(scope) {
    var root = scope || document;
    var predictiveRoots = [];
    if (root.matches && root.matches('[data-predictive-search]')) predictiveRoots.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-predictive-search]').forEach(function (predictiveRoot) { predictiveRoots.push(predictiveRoot); });
    }

    predictiveRoots.forEach(function (predictiveRoot) {
      if (predictiveRoot.getAttribute('data-predictive-ready') === 'true') return;
      var form = predictiveRoot.querySelector('[data-predictive-form]');
      var input = form ? form.querySelector('input[type="search"]') : null;
      var results = predictiveRoot.querySelector('[data-predictive-results]');
      var endpoint = predictiveRoot.getAttribute('data-predictive-url');
      if (!form || !input || !results || !endpoint) return;
      predictiveRoot.setAttribute('data-predictive-ready', 'true');

      var searchTimer = 0;
      var closeTimer = 0;
      var requestController = null;
      var requestNumber = 0;

      function closeResults() {
        window.clearTimeout(searchTimer);
        window.clearTimeout(closeTimer);
        if (requestController) requestController.abort();
        requestController = null;
        requestNumber += 1;
        results.classList.remove('is-visible', 'is-updating');
        input.setAttribute('aria-expanded', 'false');
        predictiveRoot.classList.remove('is-loading');
        closeTimer = window.setTimeout(function () {
          if (!results.classList.contains('is-visible')) {
            results.hidden = true;
            results.replaceChildren();
          }
        }, 300);
      }

      function renderResults(markup) {
        var parsed = new DOMParser().parseFromString(markup, 'text/html');
        var resultRoot = parsed.querySelector('[data-predictive-result-root]');
        if (!resultRoot) {
          closeResults();
          return;
        }
        window.clearTimeout(closeTimer);
        results.replaceChildren(resultRoot);
        results.hidden = false;
        results.getBoundingClientRect();
        window.requestAnimationFrame(function () {
          results.classList.add('is-visible');
          results.classList.remove('is-updating');
          input.setAttribute('aria-expanded', 'true');
        });
      }

      function searchProducts() {
        var term = input.value.trim();
        if (!term) {
          closeResults();
          return;
        }
        if (requestController) requestController.abort();
        requestController = new AbortController();
        requestNumber += 1;
        var currentRequest = requestNumber;
        predictiveRoot.classList.add('is-loading');
        if (!results.hidden) results.classList.add('is-updating');
        var requestUrl = endpoint + '?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search';

        fetch(requestUrl, { signal: requestController.signal, headers: { Accept: 'text/html' } })
          .then(function (response) {
            if (!response.ok) throw new Error('Predictive search request failed');
            return response.text();
          })
          .then(function (markup) {
            if (currentRequest !== requestNumber || input.value.trim() !== term) return;
            renderResults(markup);
          })
          .catch(function (error) {
            if (error.name !== 'AbortError' && currentRequest === requestNumber) closeResults();
          })
          .finally(function () {
            if (currentRequest === requestNumber) predictiveRoot.classList.remove('is-loading');
          });
      }

      input.addEventListener('input', function () {
        window.clearTimeout(searchTimer);
        if (!input.value.trim()) {
          closeResults();
          return;
        }
        searchTimer = window.setTimeout(searchProducts, 180);
      });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        window.clearTimeout(searchTimer);
        searchProducts();
      });
      predictiveRoot.addEventListener('predictive-search:close', closeResults);
    });
  }

  /* ---------- cart drawer ---------- */
  var overlay = document.getElementById('cart-overlay');
  var drawer = document.getElementById('cart-drawer');
  var body = document.getElementById('cart-body');
  var foot = document.getElementById('cart-foot');
  var fill = document.getElementById('ship-fill');
  var msg = document.getElementById('ship-msg');
  var cartAlert = document.getElementById('cart-alert');
  var subVal = document.getElementById('subtotal-val');
  var subLabel = document.getElementById('subtotal-label');
  var countEl = document.getElementById('cart-count');
  var mobileCountEls = document.querySelectorAll('[data-mobile-cart-count]');

  function openCart() { if (overlay && drawer) { overlay.classList.add('open'); drawer.classList.add('open'); document.body.style.overflow = 'hidden'; } }
  function closeCart() { if (overlay && drawer) { overlay.classList.remove('open'); drawer.classList.remove('open'); document.body.style.overflow = ''; } }

  function bindSwipeDismiss(element, direction, onDismiss) {
    if (!element || !window.PointerEvent) return;
    var candidate = false;
    var tracking = false;
    var startX = 0;
    var startY = 0;
    var startTime = 0;
    var distance = 0;

    element.addEventListener('pointerdown', function (event) {
      if (!window.matchMedia('(pointer: coarse)').matches || event.pointerType === 'mouse') return;
      if (event.target.closest('a,button,input,select,textarea,summary')) return;
      candidate = true;
      tracking = false;
      startX = event.clientX;
      startY = event.clientY;
      startTime = performance.now();
      distance = 0;
    });

    element.addEventListener('pointermove', function (event) {
      if (!candidate) return;
      var deltaX = event.clientX - startX;
      var deltaY = event.clientY - startY;
      if (!tracking) {
        if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 8) {
          candidate = false;
          return;
        }
        if (Math.abs(deltaX) < 10) return;
        tracking = true;
        element.style.transition = 'none';
        element.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      distance = Math.max(0, deltaX * direction);
      element.style.transform = 'translateX(' + (distance * direction) + 'px)';
    });

    function finishSwipe(event) {
      if (!candidate) return;
      candidate = false;
      if (!tracking) return;
      tracking = false;
      if (element.hasPointerCapture(event.pointerId)) element.releasePointerCapture(event.pointerId);
      var elapsed = Math.max(1, performance.now() - startTime);
      var velocity = distance / elapsed;
      var shouldDismiss = distance > element.getBoundingClientRect().width * .24 || velocity > .55;
      element.style.transition = '';
      if (shouldDismiss) {
        element.style.transform = 'translateX(' + (direction * 105) + '%)';
        window.setTimeout(function () {
          onDismiss();
          element.style.transform = '';
        }, 220);
      } else {
        element.style.transform = '';
      }
    }

    element.addEventListener('pointerup', finishSwipe);
    element.addEventListener('pointercancel', finishSwipe);
  }

  function showCartAlert(message) {
    if (!cartAlert) return;
    cartAlert.textContent = message || COPY.stockError || "we don't have that many in stock.";
    cartAlert.hidden = false;
  }

  function clearCartAlert() {
    if (!cartAlert) return;
    cartAlert.textContent = '';
    cartAlert.hidden = true;
  }

  function renderCart(cart) {
    clearCartAlert();
    if (countEl) countEl.textContent = cart.item_count;
    mobileCountEls.forEach(function (el) { el.textContent = cart.item_count; });
    var sub = cart.total_price;
    if (fill && msg) {
      var pct = Math.min(100, (sub / FREE) * 100);
      fill.style.setProperty('--ship-progress', String(pct / 100));
      if (sub >= FREE) { fill.classList.add('unlocked'); msg.textContent = COPY.shippingUnlocked || "you've unlocked free shipping!"; }
      else { fill.classList.remove('unlocked'); msg.textContent = (COPY.shippingAwayPrefix || "you're") + ' ' + money(FREE - sub) + ' ' + (COPY.shippingAwaySuffix || 'away from free shipping'); }
    }
    if (!body) return;
    if (cart.item_count === 0) {
      if (foot) foot.classList.add('hidden');
      body.innerHTML = '<div class="cart-empty"><h3>' + (COPY.emptyCart || 'your cart is empty!') + '</h3><a class="btn" href="' + (S.shopAllUrl || '/collections/matcha') + '" style="display:block;text-align:center;text-decoration:none">' + (COPY.shopNow || 'shop now') + '</a></div>';
      return;
    }
    if (foot) foot.classList.remove('hidden');
    body.innerHTML = cart.items.map(function (i) {
      var img = i.image ? '<img src="' + i.image + '" alt="" style="width:100%;height:100%;object-fit:cover">' : '<div class="o"></div>';
      return '' +
        '<div class="cart-item" data-key="' + i.key + '">' +
          '<div class="pic">' + img + '</div>' +
          '<div>' +
            '<h4>' + i.product_title + '</h4>' +
            '<div class="var">' + (i.variant_title ? i.variant_title : '') + '</div>' +
            '<div class="qty">' +
              '<button data-action="dec">−</button>' +
              '<span class="n">' + i.quantity + '</span>' +
              '<button data-action="inc">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="right">' +
            '<button class="trash" data-action="remove" aria-label="' + (COPY.removeItem || 'remove item') + '"><span aria-hidden="true">×</span></button>' +
            '<span class="line-price">' + money(i.final_line_price) + '</span>' +
          '</div>' +
        '</div>';
    }).join('');
    if (subLabel) subLabel.textContent = (COPY.subtotal || 'subtotal') + ' (' + cart.item_count + ' ' + (cart.item_count === 1 ? (COPY.item || 'item') : (COPY.items || 'items')) + ')';
    if (subVal) subVal.textContent = money(cart.total_price);
    wireQty();
  }

  function fetchCart(open) {
    fetch(S.cartJsonUrl || '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openCart(); });
  }

  function changeLine(key, qty) {
    clearCartAlert();
    fetch(S.cartChangeUrl || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || COPY.stockError || "we don't have that many in stock.");
        return data;
      });
    }).then(renderCart).catch(function (error) {
      showCartAlert(error.message);
    });
  }

  function wireQty() {
    if (!body) return;
    body.querySelectorAll('.cart-item').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var current = parseInt(row.querySelector('.n').textContent, 10);
      row.querySelector('[data-action="inc"]').addEventListener('click', function () { changeLine(key, current + 1); });
      row.querySelector('[data-action="dec"]').addEventListener('click', function () { changeLine(key, current - 1); });
      row.querySelector('[data-action="remove"]').addEventListener('click', function () { changeLine(key, 0); });
    });
  }

  /* add-to-cart forms across the site submit via AJAX and open the drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
      e.preventDefault();
      var data = new FormData(form);
      var productError = form.querySelector('[data-product-form-error]');
      if (productError) { productError.textContent = ''; productError.hidden = true; }
      fetch(S.cartAddUrl || '/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
        .then(function (response) {
          return response.json().then(function (result) {
            if (!response.ok) throw new Error(result.description || result.message || COPY.stockError || "we don't have that many in stock.");
            return result;
          });
        })
        .then(function () { fetchCart(true); })
        .catch(function (error) {
          if (productError) {
            productError.textContent = error.message;
            productError.hidden = false;
          } else {
            showCartAlert(error.message);
            openCart();
          }
        });
    }
  });

  if (overlay) overlay.addEventListener('click', closeCart);
  var cc = document.getElementById('cart-close');
  if (cc) cc.addEventListener('click', closeCart);
  var oc = document.getElementById('open-cart');
  if (oc) oc.addEventListener('click', function () { fetchCart(true); });
  document.querySelectorAll('[data-mobile-cart],[data-mobile-header-cart]').forEach(function (mobileCart) {
    mobileCart.addEventListener('click', function () { setMobileMenu(false); fetchCart(true); });
  });
  bindSwipeDismiss(drawer, 1, closeCart);
  bindSwipeDismiss(mobileMenu, -1, function () { setMobileMenu(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
      if (shopDrop && shopToggle) {
        shopDrop.classList.remove('open');
        shopToggle.setAttribute('aria-expanded', 'false');
      }
      if (mobileMenu && menuButton) {
        setMobileMenu(false);
      }
    }
  });

  /* initial cart paint */
  fetchCart(false);

  /* ---------- animated matcha journey ---------- */
  function initMatchaJourneys(scope) {
    var root = scope || document;
    var sections = [];
    if (root.matches && root.matches('[data-matcha-journey]')) sections.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-matcha-journey]').forEach(function (section) { sections.push(section); });
    }

    sections.forEach(function (section) {
      if (section.getAttribute('data-journey-ready') === 'true') return;
      section.setAttribute('data-journey-ready', 'true');

      var routePath = section.querySelector('[data-journey-path]');
      var dotsLayer = section.querySelector('[data-journey-dots]');
      var marker = section.querySelector('[data-journey-marker]');
      var revealItems = section.querySelectorAll('[data-journey-reveal]');
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      revealItems.forEach(function (item) {
        if (prefersReducedMotion || !('IntersectionObserver' in window)) item.classList.add('is-visible');
      });

      if (!prefersReducedMotion && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: .04, rootMargin: '20% 0px 12% 0px' });
        revealItems.forEach(function (item) { observer.observe(item); });
      }

      var regionButtons = section.querySelectorAll('.journey-pin');
      if (regionButtons.length) {
        var mobileRegionOverlay = document.querySelector('[data-journey-mobile-overlay]');
        if (!mobileRegionOverlay) {
          mobileRegionOverlay = document.createElement('div');
          mobileRegionOverlay.className = 'journey-mobile-region-overlay';
          mobileRegionOverlay.setAttribute('data-journey-mobile-overlay', '');
          mobileRegionOverlay.setAttribute('role', 'dialog');
          mobileRegionOverlay.setAttribute('aria-modal', 'true');
          mobileRegionOverlay.setAttribute('aria-label', 'matcha region details');
          mobileRegionOverlay.hidden = true;
          mobileRegionOverlay.innerHTML = '<div class="journey-mobile-region-panel"><button class="journey-mobile-region-close" type="button" aria-label="close region details">×</button><div data-journey-mobile-region-content></div></div>';
          document.body.appendChild(mobileRegionOverlay);
        }

        if (mobileRegionOverlay.getAttribute('data-overlay-ready') !== 'true') {
          mobileRegionOverlay.setAttribute('data-overlay-ready', 'true');
          var overlayClose = mobileRegionOverlay.querySelector('.journey-mobile-region-close');
          var closeMobileRegion = function () {
            var activeButton = mobileRegionOverlay._activeJourneyButton;
            mobileRegionOverlay.classList.remove('is-open');
            if (activeButton) activeButton.setAttribute('aria-expanded', 'false');
            window.setTimeout(function () {
              if (!mobileRegionOverlay.classList.contains('is-open')) mobileRegionOverlay.hidden = true;
            }, 220);
            if (activeButton) activeButton.focus({ preventScroll: true });
            mobileRegionOverlay._activeJourneyButton = null;
          };
          overlayClose.addEventListener('click', closeMobileRegion);
          mobileRegionOverlay.addEventListener('click', function (event) {
            if (event.target === mobileRegionOverlay) closeMobileRegion();
          });
          mobileRegionOverlay.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') closeMobileRegion();
          });
        }

        regionButtons.forEach(function (regionButton) {
          if (regionButton.getAttribute('data-mobile-region-ready') === 'true') return;
          regionButton.setAttribute('data-mobile-region-ready', 'true');
          regionButton.setAttribute('aria-expanded', 'false');
          regionButton.addEventListener('click', function (event) {
            if (!window.matchMedia('(max-width: 1024px)').matches) return;
            var pinWrap = regionButton.closest('.journey-pin-wrap');
            var sourceCard = pinWrap ? pinWrap.querySelector('.journey-region-card') : null;
            var overlayContent = mobileRegionOverlay.querySelector('[data-journey-mobile-region-content]');
            if (!sourceCard || !overlayContent) return;
            event.preventDefault();
            event.stopPropagation();
            if (mobileRegionOverlay._activeJourneyButton) mobileRegionOverlay._activeJourneyButton.setAttribute('aria-expanded', 'false');
            overlayContent.innerHTML = sourceCard.innerHTML;
            mobileRegionOverlay.style.setProperty('--pin-color', window.getComputedStyle(pinWrap).getPropertyValue('--pin-color'));
            mobileRegionOverlay._activeJourneyButton = regionButton;
            regionButton.setAttribute('aria-expanded', 'true');
            mobileRegionOverlay.hidden = false;
            window.requestAnimationFrame(function () {
              mobileRegionOverlay.classList.add('is-open');
              var closeButton = mobileRegionOverlay.querySelector('.journey-mobile-region-close');
              if (closeButton) closeButton.focus({ preventScroll: true });
            });
          });
        });
      }

      if (!routePath || !dotsLayer || !marker || !routePath.getTotalLength) return;
      var journeyCanvas = section.querySelector('.journey-canvas');
      var routeSvg = routePath.ownerSVGElement;
      var pathLength = 0;
      var viewBoxHeight = 2440;
      var routeStartRatio = 0;
      var routeEndRatio = 1;
      var routeDots = [];
      var svgNamespace = 'http://www.w3.org/2000/svg';
      var routeMode = '';

      function configureJourneyRoute() {
        var isMobile = window.matchMedia('(max-width: 640px)').matches;
        var mobileViewBoxWidth = 340;
        if (isMobile && journeyCanvas && journeyCanvas.offsetWidth && journeyCanvas.offsetHeight) {
          mobileViewBoxWidth = Math.max(280, Math.min(560, 2440 * (journeyCanvas.offsetWidth / journeyCanvas.offsetHeight)));
        }
        var canvasWidth = journeyCanvas ? Math.round(journeyCanvas.offsetWidth) : 0;
        var canvasHeight = journeyCanvas ? Math.round(journeyCanvas.offsetHeight) : 0;
        var nextMode = (isMobile ? 'mobile-' + Math.round(mobileViewBoxWidth) : 'desktop') + '-' + canvasWidth + '-' + canvasHeight;
        if (routeMode === nextMode) return;
        routeMode = nextMode;

        var pathData = routePath.getAttribute(isMobile ? 'data-mobile-d' : 'data-desktop-d');
        if (isMobile) {
          var outside = (mobileViewBoxWidth * .89).toFixed(1);
          var middle = (mobileViewBoxWidth * .86).toFixed(1);
          var inside = (mobileViewBoxWidth * .82).toFixed(1);
          var mobileEndX = parseFloat(middle);
          var mobileEndY = 2260;
          var tinTarget = section.querySelector('.journey-step-tin .journey-illustration');
          if (tinTarget && journeyCanvas) {
            var canvasRect = journeyCanvas.getBoundingClientRect();
            var tinRect = tinTarget.getBoundingClientRect();
            if (canvasRect.width && canvasRect.height && tinRect.width && tinRect.height) {
              mobileEndX = ((tinRect.left + (tinRect.width * .5) - canvasRect.left) / canvasRect.width) * mobileViewBoxWidth;
              mobileEndY = ((tinRect.top + (tinRect.height * .5) - canvasRect.top) / canvasRect.height) * 2440;
              mobileEndX = Math.max(mobileViewBoxWidth * .25, Math.min(mobileViewBoxWidth * .88, mobileEndX));
              mobileEndY = Math.max(1500, Math.min(2380, mobileEndY));
            }
          }
          var y20 = (mobileEndY * .2).toFixed(1);
          var y40 = (mobileEndY * .4).toFixed(1);
          var y60 = (mobileEndY * .6).toFixed(1);
          var y80 = (mobileEndY * .8).toFixed(1);
          var y92 = (mobileEndY * .92).toFixed(1);
          var y96 = (mobileEndY * .96).toFixed(1);
          pathData = [
            'M', middle, '70',
            'C', outside, (mobileEndY * .08).toFixed(1), outside, (mobileEndY * .14).toFixed(1), middle, y20,
            'C', inside, (mobileEndY * .27).toFixed(1), inside, (mobileEndY * .34).toFixed(1), middle, y40,
            'C', outside, (mobileEndY * .47).toFixed(1), outside, (mobileEndY * .54).toFixed(1), middle, y60,
            'C', inside, (mobileEndY * .67).toFixed(1), inside, (mobileEndY * .74).toFixed(1), middle, y80,
            'C', outside, (mobileEndY * .85).toFixed(1), outside, (mobileEndY * .89).toFixed(1), middle, y92,
            'C', middle, y96, mobileEndX.toFixed(1), (mobileEndY * .98).toFixed(1), mobileEndX.toFixed(1), mobileEndY.toFixed(1)
          ].join(' ');
        }
        if (pathData) routePath.setAttribute('d', pathData);
        if (routeSvg) routeSvg.setAttribute('viewBox', isMobile ? '0 0 ' + mobileViewBoxWidth.toFixed(1) + ' 2440' : '0 0 1200 2440');

        pathLength = routePath.getTotalLength();
        viewBoxHeight = routeSvg && routeSvg.viewBox ? routeSvg.viewBox.baseVal.height : 2440;
        var routeStart = routePath.getPointAtLength(0);
        var routeEnd = routePath.getPointAtLength(pathLength);
        routeStartRatio = routeStart.y / viewBoxHeight;
        routeEndRatio = routeEnd.y / viewBoxHeight;

        dotsLayer.replaceChildren();
        routeDots = [];
        var dottedLength = Math.max(1, pathLength - (isMobile ? 58 : 78));
        var tinArtworkForDots = section.querySelector('.journey-step-tin .journey-illustration');
        if (tinArtworkForDots && routeSvg && routeSvg.viewBox) {
          var routeRect = routeSvg.getBoundingClientRect();
          var tinArtworkRect = tinArtworkForDots.getBoundingClientRect();
          var routeViewBox = routeSvg.viewBox.baseVal;
          if (routeRect.width && routeRect.height && tinArtworkRect.width && tinArtworkRect.height && routeViewBox.width && routeViewBox.height) {
            var tinLeft = ((tinArtworkRect.left - routeRect.left) / routeRect.width) * routeViewBox.width;
            var tinRight = ((tinArtworkRect.right - routeRect.left) / routeRect.width) * routeViewBox.width;
            var tinTop = ((tinArtworkRect.top - routeRect.top) / routeRect.height) * routeViewBox.height;
            var tinBottom = ((tinArtworkRect.bottom - routeRect.top) / routeRect.height) * routeViewBox.height;
            var edgePaddingX = 16 * (routeViewBox.width / routeRect.width);
            var edgePaddingY = 16 * (routeViewBox.height / routeRect.height);
            var stopBeforeTin = 22 * (routeViewBox.height / routeRect.height);

            for (var sampleIndex = 0; sampleIndex <= 480; sampleIndex += 1) {
              var sampleLength = pathLength * (.5 + (.5 * (sampleIndex / 480)));
              var samplePoint = routePath.getPointAtLength(sampleLength);
              var reachesTin = samplePoint.x >= tinLeft - edgePaddingX &&
                samplePoint.x <= tinRight + edgePaddingX &&
                samplePoint.y >= tinTop - edgePaddingY &&
                samplePoint.y <= tinBottom + edgePaddingY;
              if (reachesTin) {
                dottedLength = Math.max(1, sampleLength - stopBeforeTin);
                break;
              }
            }
          }
        }
        var dotSpacing = isMobile ? 19 : 22;
        var dotCount = Math.max(2, Math.floor(dottedLength / dotSpacing));
        for (var dotIndex = 0; dotIndex <= dotCount; dotIndex += 1) {
          var dotPoint = routePath.getPointAtLength(dottedLength * (dotIndex / dotCount));
          var routeDot = document.createElementNS(svgNamespace, 'circle');
          routeDot.setAttribute('class', 'journey-route-speck');
          routeDot.setAttribute('cx', dotPoint.x);
          routeDot.setAttribute('cy', dotPoint.y);
          routeDot.setAttribute('r', isMobile ? '2.8' : '3.5');
          dotsLayer.appendChild(routeDot);
          routeDots.push(routeDot);
        }
      }

      configureJourneyRoute();
      var targetAmount = prefersReducedMotion ? 1 : 0;
      var currentAmount = 0;
      var animationFrame = 0;
      var lastPassedDot = -1;

      function readJourneyPosition() {
        var rect = (journeyCanvas || section).getBoundingClientRect();
        var startY = rect.top + (rect.height * routeStartRatio);
        var endY = rect.top + (rect.height * routeEndRatio);
        var startTrigger = window.innerHeight * .8;
        var endTrigger = window.innerHeight * .76;
        var animationDistance = Math.max(1, (endY - startY) + (startTrigger - endTrigger));
        var travelled = startTrigger - startY;
        targetAmount = prefersReducedMotion ? 1 : Math.max(0, Math.min(1, travelled / animationDistance));
      }

      function drawJourney(amount) {
        var passedDot = Math.floor(amount * (routeDots.length - 1));
        if (passedDot !== lastPassedDot) {
          routeDots.forEach(function (routeDot, index) {
            routeDot.classList.toggle('is-passed', index <= passedDot);
          });
          lastPassedDot = passedDot;
        }
        var markerLength = pathLength * amount;
        var point = routePath.getPointAtLength(markerLength);
        marker.setAttribute('transform', 'translate(' + point.x.toFixed(2) + ' ' + point.y.toFixed(2) + ')');
        var arrivalFade = amount < .975 ? 1 : Math.max(0, (1 - amount) / .025);
        marker.style.opacity = arrivalFade.toFixed(3);
        marker.style.visibility = amount >= .9995 ? 'hidden' : 'visible';
      }

      function animateJourney() {
        var distance = targetAmount - currentAmount;
        currentAmount += distance * .11;
        if (Math.abs(distance) < .0007) currentAmount = targetAmount;
        drawJourney(currentAmount);
        if (currentAmount !== targetAmount) animationFrame = window.requestAnimationFrame(animateJourney);
        else animationFrame = 0;
      }

      function requestPaint() {
        readJourneyPosition();
        if (!animationFrame) animationFrame = window.requestAnimationFrame(animateJourney);
      }

      readJourneyPosition();
      if (prefersReducedMotion) {
        currentAmount = 1;
        drawJourney(1);
      } else {
        drawJourney(0);
        animationFrame = window.requestAnimationFrame(animateJourney);
      }
      window.addEventListener('scroll', requestPaint, { passive: true });
      window.addEventListener('resize', function () {
        configureJourneyRoute();
        requestPaint();
      });
      if ('ResizeObserver' in window && journeyCanvas) {
        var journeyResizeObserver = new ResizeObserver(function () {
          configureJourneyRoute();
          requestPaint();
        });
        journeyResizeObserver.observe(journeyCanvas);
      }
    });
  }

  function initCollectionWaves(scope) {
    var root = scope || document;
    var waveCards = [];
    if (root.matches && root.matches('[data-collection-wave-card]')) waveCards.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-collection-wave-card]').forEach(function (card) { waveCards.push(card); });
    }

    waveCards.forEach(function (waveCard) {
      if (waveCard.getAttribute('data-wave-ready') === 'true') return;
      var clipPath = waveCard.querySelector('[data-collection-wave-path]');
      var edgePath = waveCard.querySelector('[data-collection-wave-edge]');
      var productCard = waveCard.closest('a') || waveCard.closest('.card') || waveCard;
      if (!clipPath || !edgePath || !productCard) return;
      waveCard.setAttribute('data-wave-ready', 'true');

      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var reveal = 0;
      var target = 0;
      var phase = 0;
      var animationFrame = 0;

      function curveFor(amount) {
        var eased = amount * amount * (3 - (2 * amount));
        var baseline = -60 + (1120 * eased);
        var amplitude = 42 + (Math.sin(amount * Math.PI) * 24);
        var leftY = baseline + (Math.sin(phase) * amplitude * .18);
        var firstY = baseline - amplitude;
        var middleY = baseline + (amplitude * .72);
        var secondY = baseline - (amplitude * .88);
        var rightY = baseline + (Math.cos(phase) * amplitude * .2);
        return 'M0 ' + leftY.toFixed(2) +
          ' C120 ' + leftY.toFixed(2) + ', 185 ' + firstY.toFixed(2) + ', 300 ' + baseline.toFixed(2) +
          ' C410 ' + middleY.toFixed(2) + ', 520 ' + middleY.toFixed(2) + ', 620 ' + baseline.toFixed(2) +
          ' C735 ' + secondY.toFixed(2) + ', 865 ' + rightY.toFixed(2) + ', 1000 ' + rightY.toFixed(2);
      }

      function drawWave() {
        var curve = curveFor(reveal);
        clipPath.setAttribute('d', curve + ' L1000 0 L0 0 Z');
        edgePath.setAttribute('d', curve);
        edgePath.style.opacity = String(Math.min(.72, Math.max(0, (1 - reveal) * 9)));
      }

      function animateWave() {
        var distance = target - reveal;
        reveal += distance * .06;
        phase += .09;
        if (Math.abs(distance) < .002) reveal = target;
        drawWave();
        if (reveal !== target) animationFrame = window.requestAnimationFrame(animateWave);
        else animationFrame = 0;
      }

      function setWaveTarget(nextTarget) {
        target = nextTarget;
        if (prefersReducedMotion) {
          reveal = target;
          drawWave();
          return;
        }
        if (!animationFrame) animationFrame = window.requestAnimationFrame(animateWave);
      }

      function resetWave() {
        target = 0;
        reveal = 0;
        phase = 0;
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        animationFrame = 0;
        drawWave();
      }

      if (canHover) {
        productCard.addEventListener('mouseenter', function () { setWaveTarget(1); });
        productCard.addEventListener('mouseleave', function () { setWaveTarget(0); });
        productCard.addEventListener('focusin', function () { setWaveTarget(1); });
        productCard.addEventListener('focusout', function (event) {
          if (!productCard.contains(event.relatedTarget)) setWaveTarget(0);
        });
      }
      productCard.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse') resetWave();
      });
      window.addEventListener('pagehide', resetWave);
      window.addEventListener('pageshow', resetWave);
      resetWave();
    });
  }

  function initFallbackFaq(scope) {
    var root = scope || document;
    var detailsItems = [];
    if (root.matches && root.matches('.fallback-faq details')) detailsItems.push(root);
    if (root.querySelectorAll) root.querySelectorAll('.fallback-faq details').forEach(function (item) { detailsItems.push(item); });

    detailsItems.forEach(function (details) {
      if (details.getAttribute('data-smooth-faq') === 'true') return;
      var summary = details.querySelector('summary');
      var answer = summary ? summary.nextElementSibling : null;
      if (!summary || !answer) return;
      details.setAttribute('data-smooth-faq', 'true');
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      answer.style.height = details.open ? 'auto' : '0px';
      answer.style.marginBottom = details.open ? '1.25rem' : '0px';
      var timer;

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        window.clearTimeout(timer);
        var opening = !details.open;
        if (opening) {
          details.open = true;
          summary.setAttribute('aria-expanded', 'true');
          answer.style.transitionDuration = '.38s';
          answer.style.height = '0px';
          answer.style.marginBottom = '0px';
          window.requestAnimationFrame(function () {
            answer.style.height = answer.scrollHeight + 'px';
            answer.style.marginBottom = '1.25rem';
          });
          timer = window.setTimeout(function () {
            if (details.open) answer.style.height = 'auto';
          }, 390);
        } else {
          summary.setAttribute('aria-expanded', 'false');
          answer.style.transitionDuration = '.26s';
          answer.style.height = answer.scrollHeight + 'px';
          window.requestAnimationFrame(function () {
            answer.style.height = '0px';
            answer.style.marginBottom = '0px';
          });
          timer = window.setTimeout(function () {
            details.open = false;
          }, 270);
        }
      });
    });
  }

  function repairKnownPageLinks(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) return;
    root.querySelectorAll('[data-wholesale-link-scope]').forEach(function (linkScope) {
      var wholesaleUrl = linkScope.getAttribute('data-wholesale-url');
      if (!wholesaleUrl) return;
      linkScope.querySelectorAll('a').forEach(function (link) {
        var href = link.getAttribute('href') || '';
        var text = link.textContent.trim().toLowerCase();
        if (href.indexOf('/pages/wholesale') !== -1 || href.indexOf('sumi-wholesale') !== -1 || text.indexOf('wholesale') !== -1 || text.indexOf('groothandel') !== -1 || text.indexOf('grosshandel') !== -1 || text.indexOf('großhandel') !== -1) {
          link.setAttribute('href', wholesaleUrl);
        }
      });
    });
  }

  function repairPrivacyPolicyLinks(scope) {
    var root = scope || document;
    var privacyUrl = document.body && document.body.getAttribute('data-sumi-privacy-url');
    if (!privacyUrl || !root.querySelectorAll) return;
    root.querySelectorAll('a[href*="/policies/privacy-policy"]').forEach(function (link) {
      link.setAttribute('href', privacyUrl);
    });
  }

  var privacyLinkObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('a[href*="/policies/privacy-policy"]')) node.setAttribute('href', document.body.getAttribute('data-sumi-privacy-url'));
        repairPrivacyPolicyLinks(node);
      });
    });
  });

  initCollectionWaves(document);
  initMatchaJourneys(document);
  repairKnownPageLinks(document);
  repairPrivacyPolicyLinks(document);
  privacyLinkObserver.observe(document.body, { childList: true, subtree: true });
  initFallbackFaq(document);
  initPredictiveSearch(document);
  document.addEventListener('shopify:section:load', function (event) {
    initCollectionWaves(event.target);
    initMatchaJourneys(event.target);
    repairKnownPageLinks(event.target);
    repairPrivacyPolicyLinks(event.target);
    initFallbackFaq(event.target);
    initPredictiveSearch(event.target);
  });
})();
